import { useNextRouter } from '@/data/Content/_NextRouter';
import { PROTECTED_PAGES } from 'shared/custom/constants/commonConstants';

/**
 * Redirect if the user is in a protected url
 */
export const useRedirectIfProtected = () => {
	const router = useNextRouter();
	const redirectIfProtected = () => {
		if (PROTECTED_PAGES.some((path) => router.asPath.includes(path))) router.push('/');
	};
	return { redirectIfProtected };
};
